import * as React from "react";
import { useState } from "react";
import toast from "react-hot-toast";
import dayjs from "dayjs";
import axiosInstant from "../../../api";
import ExportFieldsModal, { ExportField } from "../../../components/ExportFieldsModal/ExportFieldsModal";

const fieldsList: ExportField[] = [
    { label: "First Name", value: "firstName" },
    { label: "Last Name", value: "lastName" },
    { label: "Display Name", value: "displayName" },
    { label: "Professions", value: "professionsTxt" },
    { label: "Phone Number", value: "phoneNumber" },
    { label: "Email", value: "emailAddress" },
    { label: "State", value: "state" },
    { label: "Ethnicity", value: "ethnicity" },
    { label: "Referral Note", value: "referringSource" },
    { label: "Referring User", value: "referredByTxt" },
    { label: "Referrals", value: "referralsTxt" },
    { label: "Agent Name", value: "agencyName" },
    { label: "Agent Email", value: "agencyEmail" },
    { label: "Agent Phone", value: "agencyPhoneNumber" },
    { label: "Bio", value: "description" },
    { label: "Key Points", value: "keyPointsTxt" },
    { label: "Twitter", value: "twitter" },
    { label: "Instagram", value: "instagram" },
    { label: "Tik Tok", value: "tiktok" },
    { label: "Website", value: "website" },
    { label: "Linkedin", value: "linkedin" },
    { label: "ID", value: "userid" },
    { label: "Date Of Birth", value: "dateOfBirth" },
    { label: "Age", value: "age" },
    { label: "Auto Login Url", value: "autoLogin" },
    { label: "Gender", value: "gender" },
];

export default function DownloadCsv(props: any) {
    const [loading, setLoading] = useState(false);

    const handleClose = () => props.setShowDialog(false);

    const downloadUsers = (selectedFields: ExportField[]) => {
        setLoading(true);
        let filtersObj: Record<string, any> = {};

        if (props?.filters instanceof URLSearchParams) {
            filtersObj = Object.fromEntries(props.filters.entries());
        } else if (props?.filters && props.filters.searchParams instanceof URLSearchParams) {
            filtersObj = Object.fromEntries(props.filters.searchParams.entries());
        } else if (props?.filters && typeof props.filters === "object") {
            filtersObj = { ...props.filters };
        }

        axiosInstant
            .get("/users/prosCsv", {
                params: {
                    ...filtersObj,
                    selectedFields: JSON.stringify(selectedFields),
                    limit: 0,
                },
            })
            .then((response) => {
                const a = document.createElement("a");
                a.href = response.data;
                a.download = `experts-${dayjs().format("YYYY-MM-DD")}.csv`;
                document.body.appendChild(a);
                a.click();
                a.remove();
                toast.success("Experts CSV downloaded");
                handleClose();
            })
            .catch((error) => {
                console.error(error.response);
                toast.error("Unable to download. Kindly try again.");
            })
            .finally(() => {
                setLoading(false);
            });
    };

    return (
        <ExportFieldsModal
            open={props.showDialog}
            onClose={handleClose}
            fields={fieldsList}
            loading={loading}
            onExport={downloadUsers}
        />
    );
}
